export const APP_FOOTER_HEIGHT = 48;
export const APP_FOOTER_HEIGHT_VAR = '--app-footer-height';

export const APP_CONTENT_MIN_HEIGHT = `calc(100vh - var(${APP_FOOTER_HEIGHT_VAR}, 0px))`;
export const APP_CONTENT_MIN_HEIGHT_DVH = `calc(100dvh - var(${APP_FOOTER_HEIGHT_VAR}, 0px))`;
